import React, { useRef, useEffect } from 'react';
import Toaster from './ui/toast';
import { setToasterRef } from '../lib/toast';

/**
 * Renders the shadcn-style Toaster and registers its ref with the global toast API.
 * Wrap the app (e.g. in App.js) with this provider so toast.success(), toast.error(), etc. work.
 */
export default function ToastProvider({ children, defaultPosition = 'bottom-right' }) {
  const toasterRef = useRef(null);

  useEffect(() => {
    setToasterRef(toasterRef);
    return () => setToasterRef(null);
  }, []);

  return (
    <>
      {children}
      <Toaster ref={toasterRef} defaultPosition={defaultPosition} />
    </>
  );
}
